import script from "./ClientJourneyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientJourneyPage.vue?vue&type=script&setup=true&lang=js"

import "./ClientJourneyPage.vue?vue&type=style&index=0&id=f1060318&lang=scss"

const __exports__ = script;

export default __exports__